import { createTheme } from "@mui/material/styles";

/**
 * Returns a MUI theme configured for light or dark mode.
 * @param {'light'|'dark'} mode
 */
export default function getTheme(mode) {
  return createTheme({
    palette: {
      mode,
      primary: { main: "#90caf9" },
      secondary: { main: "#f48fb1" },
      error: { main: "#f44336" },
      background: {
        default: mode === "light" ? "#f5f5f5" : "#121212",
        paper: mode === "light" ? "#ffffff" : "#1d1d1d",
      },
      text: {
        primary: mode === "light" ? "#000000" : "#ffffff",
        secondary: mode === "light" ? "#111111" : "#eeeeee",
      },
      // Chat-specific colors
      chat: {
        container: {
          background: mode === "light" ? "#ffffff" : "#1e1e1e",
          text: mode === "light" ? "#000000" : "#ffffff",
        },
        user: {
          background: mode === "light" ? "#e3f2fd" : "#0d47a1",
          text: mode === "light" ? "#333333" : "#e3f2fd",
        },
        assistant: {
          background: mode === "light" ? "#ffe4ca" : "#444",
          text: mode === "light" ? "#333333" : "#ffffff",
        },
      },
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            margin: "8px 0",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            margin: "16px 0",
          },
        },
      },
    },
  });
}
